import {
    GETALLGATEWAYMAPPINGLIST_SUCCESS,
    GETALLGATEWAYMAPPINGLIST_FAILED,
    RESET_GETALLGATEWAYMAPPINGLIST,
    LOADING_GETALLGATEWAYMAPPINGLIST,
    NETWORK_ERROR_GETALLGATEWAYMAPPINGLIST,
} from "../types";

const initialState = {
    isLoading: false,
    failed: false,
    success: false,
    nvalidRequest: false,
    data: {},
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_GETALLGATEWAYMAPPINGLIST: {
            return {
                ...state,
                isLoading: true,
                failed: false,
                success: false,
                invalidRequest: false,
                data: {},
            };
        }
        case GETALLGATEWAYMAPPINGLIST_FAILED: {
            return {
                ...state,
                isLoading: false,
                failed: true,
                success: false,
                invalidRequest: false,
                data: action.payload,
            };
        }
        case GETALLGATEWAYMAPPINGLIST_SUCCESS: {
            return {
                ...state,
                isLoading: false,
                failed: false,
                success: true,
                invalidRequest: false,
                data: action.payload,
            };
        }
        case NETWORK_ERROR_GETALLGATEWAYMAPPINGLIST: {
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: "",
            };
        }
        case RESET_GETALLGATEWAYMAPPINGLIST: {
            return (state = initialState);
        }

        default:
            return state;
    }
};
